import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import { SStrapiService } from '@slg/web-customer-shared';
import About from '@/components/strapi/About.vue';
import AdditionalInfo from '@/components/strapi/AdditionalInfo.vue';
import TryOurApp from '@/components/strapi/TryOurApp.vue';
import BookingForm from '@/components/bookingForm/BookingForm.vue';
import BookingBg from '@/components/bookingForm/BookingBg.vue';
import { useGtm, useCmsLocaleReload } from '@/composables';


const __default__ = {
  name: 'BookingPage',
  metaInfo: {
    // override the parent template and just use the above title only
    titleTemplate: 'Booking',
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { property: 'og:site_name', content: 'MILO booking app' },
    ],
  },
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const { trackGtmEvent } = useGtm();
const homePageData = ref<Record<string, any> | null>(null);

async function getHomePageData() {
  try {
    homePageData.value = await SStrapiService.getHomePage();
  } catch (error) {
    // to-do rethink about catch
  }
}

async function loadCmsData() {
  await getHomePageData();
}

useCmsLocaleReload(loadCmsData);

onMounted(() => {
  trackGtmEvent(
    'Booking page',
    'Page',
    'Loaded',
    'Booking page is loaded',
  );
});

return { __sfc: true,trackGtmEvent, homePageData, getHomePageData, loadCmsData, About, AdditionalInfo, TryOurApp, BookingForm, BookingBg }
}

})